import React from 'react';
import './home.css'
import Header from '../components/layout/header';
import Sec1 from '../sections/sec1';
import Sec2 from '../sections/sec2';
import Sec3 from '../sections/sec3';
import Sec4 from '../sections/sec4';
import Sec5 from '../sections/sec5';
import Footer from '../components/layout/footer';
import Responsivemsg from '../sections/responsive-msg';
import Preloader from "../sections/loading";
import  { useState } from "react";

const Home = () => {
        const [loading, setLoading] = useState(true);

    if (loading) {
        return <Preloader onFinish={() => setLoading(false)} />;}

    return (<>


        <Header />
        <main>
            <Sec1 />
            <Sec2 />
            <Sec3 />
            <Sec4 />
            <Sec5 />
            <Responsivemsg />
        </main>

        <Footer />
    </>  );
}
 
export default Home;